export const enum ErrorResponseType {
  NotFound = 'NOT_FOUND',
  AccessDenied = 'ACCESS_DENIED',
}
